import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { onboardingServices } from "../../services/onboardingServices";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import { isRequiredValid } from "./isRequired";
import { getFileNameByPath, isEmptyDash } from "../../constant";
import FileViewerModal from "../common/viewModal.js";
import MediaListModal from "../common/mediaListModal.js";
import { isClearformVaild } from "./isClearform";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  right: "50%",
  transform: "translate(-50%, -50%)",
  width: "65%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  // overflowY: "auto",
  marginTop: "5rem",
};

function OnboardingStepOne(props) {
  const fileRef = useRef([]);
  let navigate = useNavigate();
  const navigateUrl = (url) => {
    navigate(url);
  }
  const [open, setOpen] = useState(false);
  const [formStepFieldsDetails, setFormStepFieldsDetails] = useState([]);
  const [
    formStepFieldsDetailsVerification,
    setFormStepFieldsDetailsVerification,
  ] = useState([]);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const handleModalOpen = () => setIsModalOpen(true);
  const [isLoading, setIsLoading] = useState(false);
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const [fileSrc, setFileSrc] = useState();
  const [isModallOpen, setIsModallOpen] = useState(false);
  const [isMediaListModalOpen, setIsMediaListModalOpen] = useState(false);
  const [uploadFilesObj, setUploadFilesObj] = useState({});
  const [GSTState, setGSTState] = useState();

  const openModal = (src) => {
    setFileSrc(src);
    setIsModallOpen(true);
  };

  const closeModal = () => {
    setFileSrc();
    setIsModallOpen(false);
  };

  const closeMediaListModal = () => {
    setUploadFilesObj({});
    setIsMediaListModalOpen(false);
  };

  useEffect(() => {
    setFormStepFieldsDetails(props?.formStepFieldsDetails?.sections[0]?.fields);
  }, [props?.formStepFieldsDetails?.sections[0]?.fields]);

  useEffect(() => {
    setFormStepFieldsDetailsVerification(
      props?.formStepFieldsDetails?.sections[1]?.fields
    );
  }, [props?.formStepFieldsDetails?.sections[1]?.fields]);

  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };

  const handleClick = (ele, isChild, headName, i, j) => {
    // let filterData = fileRef.current.filter(ele => ele?.id == id); 
    // filterData[0].click(); 
    ele.isChild = isChild;
    ele.headName = headName;
    ele.isUploadOption = true;
    ele.i = i;
    ele.j = j;
    setUploadFilesObj(ele);
    setIsMediaListModalOpen(true);
  };

  const isStrValid = (childArr) => {
    let status = false;
    for (let i = 0; i < childArr.length; i++) {
      if (childArr[i].type == "Dropdown") {
        let selectedOptionId = childArr[i].optionId;
        let filterData = childArr[i].options.filter(
          (ele) => ele?._id == selectedOptionId
        );
        if (filterData.length > 0) {
          if (filterData[0]?.optionName == "Yes") {
            status = true;
          } else {
            status = false;
          }
        }
      }
    }

    return status;
  };

  const uploadFile = (e, ele, i) => {
    e.preventDefault();
    let formData = new FormData();
    let files = e.target.files[0];
    formData.append("file", e.target.files[0]);
    setIsLoading(true);
    onboardingServices
      .uploadFile(formData)
      .then(function (response) {
        if (response?.data?.success === true) {
          setUrl(response?.data?.data, ele, i, files);
          // formStepFieldsDetailsInitial[i].answer = e.target.value;
          // setFormStepFieldsDetails(formStepFieldsDetailsInitial);
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };

  const onTextChange = (e, ele, i) => {
    let formStepFieldsDetailsInitial = [...formStepFieldsDetails];
    if (ele?.questionId === "65dda2f33e446a7c0e67c9c6") {
      formStepFieldsDetailsInitial[i].answer =
        e.target.value.toLocaleUpperCase();
    } else {
      formStepFieldsDetailsInitial[i].answer = e.target.value;
    }
    setFormStepFieldsDetails(formStepFieldsDetailsInitial);
    formStepFieldsDetailsInitial[i].errMsg = '';
  };



  const onSelectChange = (e, ele, i) => {
    let formStepFieldsDetailsInitial = [...formStepFieldsDetails];
    formStepFieldsDetailsInitial[i].optionId = e.target.value;

    if (ele.name === "Country") {
      let nextField = formStepFieldsDetailsInitial[i + 3];
      if (nextField) {
        if (!nextField.originalOptions) {
          nextField.originalOptions = [...nextField.options];
        }
        nextField.options = nextField.originalOptions.filter(
          (item) => item.dependentOptionId === e.target.value
        );

        const previousOptionId = formStepFieldsDetailsInitial[i + 3];
        if (
          previousOptionId &&
          !nextField.options.some((option) => option.id === previousOptionId)
        ) {
          formStepFieldsDetailsInitial[i + 3].optionId = "";
        }
      }
    }
    setFormStepFieldsDetails(formStepFieldsDetailsInitial);
    formStepFieldsDetailsInitial[i].errMsg = '';
  };

  const onMultiSelectChange = (e, ele, i, multiFieldEle, j) => {
    setGSTState(e.target.value);
    let formStepFieldsDetailsInitial = [...formStepFieldsDetails];
    if (ele.isConditional === true && multiFieldEle.isDeciding === true) {
      formStepFieldsDetailsInitial[i].optionId = e.target.value;
    }
    formStepFieldsDetailsInitial[i].child[j].optionId = e.target.value;
    setFormStepFieldsDetails(formStepFieldsDetailsInitial);
    formStepFieldsDetailsInitial[i].errMsg = '';
    // const updatedSections = [
    //   {
    //     ...props?.formStepFieldsDetails?.sections[0],
    //     fields: [...formStepFieldsDetailsInitial],
    //   },
    //   {
    //     ...props?.formStepFieldsDetails?.sections[1],
    //     fields: [...formStepFieldsDetailsVerification],
    //   },
    // ];

    // const validationResult = isRequiredValid(updatedSections);
    // if (!validationResult.isValid) {
    //   setFormStepFieldsDetails(validationResult.sections[0]?.fields);
    //   setFormStepFieldsDetailsVerification(validationResult.sections[1]?.fields);
    //   // openAlert(true, "error", `Please fill all required fields.`);
    // }
  };

  const onMultiBooleanSelectChange = (e, ele, i, multiFieldEle, j) => {
    let { value } = e.target;
    let formStepFieldsDetailsInitial = [...formStepFieldsDetails];
    let filterData = formStepFieldsDetailsInitial[i].child[j].options.filter(
      (ele) => ele?._id == value
    );
    if (filterData[0].optionName == "Yes") {
      formStepFieldsDetailsInitial[i].child[j + 1].childAnswer = "";
    }
    if (filterData[0].optionName == "No") {
      formStepFieldsDetailsInitial[i].child[j + 1].childAnswer = "";
    }
    formStepFieldsDetailsInitial[i].child[j].optionId = e.target.value;
    setFormStepFieldsDetails(formStepFieldsDetailsInitial);
  };

  const onMultiBooleanMSMESelectChange = (e, ele, i, multiFieldEle, j) => {
    let { value } = e.target;
    let formStepFieldsDetailsInitial = [...formStepFieldsDetails];
    let filterData = formStepFieldsDetailsInitial[i].child[j].options.filter(
      (ele) => ele?._id == value
    );
    if (filterData[0].optionName == "Yes") {
      formStepFieldsDetailsInitial[i].child[j + 2].childAnswer = "";
    }
    if (filterData[0].optionName == "No") {
      formStepFieldsDetailsInitial[i].child[j + 2].childAnswer = "";
    }
    formStepFieldsDetailsInitial[i].child[j].optionId = e.target.value;
    setFormStepFieldsDetails(formStepFieldsDetailsInitial);
  };

  const getAnsFromOptId = (response, options) => {
    let filterData = options.filter((ele) => ele?._id == response?.optionId);
    return filterData[0];
  };

  const onMultiTextChange = (e, ele, i, multiFieldEle, j) => {
    let formStepFieldsDetailsInitial = [...formStepFieldsDetails];
    let { value } = e.target;
    if (
      ele?.uniqueName === "GSTIN" &&
      getAnsFromOptId(ele?.child[0], ele?.child[0].options).optionName ===
      "Yes" &&
      value.length > 2
    ) {
      let str = value.slice(0, 2);
      // let obj = {};
      let index = -1;
      for (let x = 0; x < formStepFieldsDetailsInitial.length; x++) {
        if (formStepFieldsDetailsInitial[x].uniqueName === "GSTINState") {
          index = x;
        }
      }

      let filterData = formStepFieldsDetailsInitial[index].options.filter(
        (ele) => ele?.stateCode == str
      );
      if (filterData.length > 0) {
        formStepFieldsDetailsInitial[index].optionId = filterData[0]._id;
      } else {
        formStepFieldsDetailsInitial[index].optionId = "null";
      }
    }
    formStepFieldsDetailsInitial[i].child[j].childAnswer = value;
    setFormStepFieldsDetails(formStepFieldsDetailsInitial);
    formStepFieldsDetailsInitial[i].errMsg = '';
  };
  const encodeKey = (key) => {
    if (!key) return key;
    return encodeURIComponent(key);
  };

  const setUrl = (data, ele, i, files) => {
    let formStepFieldsDetailsInitial = [...formStepFieldsDetails];
    let obj = {
      // key: encodeKey(data?.data?.key),
      key: encodeKey(data?.data?.Key),
      name: files?.name,
    };
    //formStepFieldsDetailsInitial[i].answer = data?.data?.Key;
    formStepFieldsDetailsInitial[i].files[0] = obj;
    setFormStepFieldsDetails(formStepFieldsDetailsInitial);
    formStepFieldsDetailsInitial[i].errMsg = '';
  };

  const uploadMultiChildFile = (e, ele, i, multiFieldEle, j) => {
    e.preventDefault();
    let formData = new FormData();
    let files = e.target.files[0];
    formData.append("file", e.target.files[0]);
    setIsLoading(true);
    onboardingServices
      .uploadFile(formData)
      .then(function (response) {
        if (response?.data?.success == true) {
          setMultiChildUrl(
            response?.data?.data,
            ele,
            i,
            multiFieldEle,
            j,
            files
          );
          // formStepFieldsDetailsInitial[i].answer = e.target.value;
          // setFormStepFieldsDetails(formStepFieldsDetailsInitial);
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const setMultiChildUrl = (data, ele, i, multiFieldEle, j, files) => {
    let formStepFieldsDetailsInitial = [...formStepFieldsDetails];
    let obj = {
      key: data?.data?.key,
      name: files?.name,
    };
    //formStepFieldsDetailsInitial[i].child[j].childAnswer = data?.data?.Key;
    formStepFieldsDetailsInitial[i].child[j].files[0] = obj;
    setFormStepFieldsDetails(formStepFieldsDetailsInitial);
  };

  const onUploadMedia = (resData, uploadObj, files) => {
    let formStepFieldsDetailsInitial = [...formStepFieldsDetails];
    let obj = {
      // key: encodeKey(resData?.data?.key),
      key: encodeKey(resData?.data?.Key),
      name: files?.name,
    };
    if (uploadObj?.isChild === true) {
      formStepFieldsDetailsInitial[uploadObj?.i].child[uploadObj?.j].files.push(
        obj
      );
    } else {
      formStepFieldsDetailsInitial[uploadObj?.i]?.files.push(obj);
    }
    setFormStepFieldsDetails(formStepFieldsDetailsInitial);
    formStepFieldsDetailsInitial[uploadObj?.i].errMsg = '';
  };

  // const onSelectChangeVerification = (e, ele, i) => {
  //   let formStepFieldsDetailsInitial = [...formStepFieldsDetailsVerification]; 
  //   formStepFieldsDetailsInitial[i].optionId = e.target.value;
  //   setFormStepFieldsDetailsVerification(formStepFieldsDetailsInitial);
  // };

  const onMultiSelectChangeVerification = (e, ele, i, multiFieldEle, j) => {
    let formStepFieldsDetailsInitial = [...formStepFieldsDetailsVerification];
    // let obj = {
    //   "childquestionId": multiFieldEle?._id,
    //   "childAnswer": null,
    //   "optionId": e.target.value,
    // }; 
    formStepFieldsDetailsInitial[i].child[j].optionId = e.target.value;
    setFormStepFieldsDetailsVerification(formStepFieldsDetailsInitial);
  };

  const onSelectVRFChange = (e, ele, i, multiFieldEle, j) => {
    let { value } = e.target;
    let formStepFieldsDetailsInitial = [...formStepFieldsDetailsVerification];
    // let filterData =  formStepFieldsDetailsInitial[i].child[j].options.filter(ele => ele?._id == value);
    // if (filterData[0].optionName == "Yes") {
    //   formStepFieldsDetailsInitial[i].child[j+1].childAnswer = "";
    // }
    // if (filterData[0].optionName == "No") {
    //   formStepFieldsDetailsInitial[i].child[j+1].childAnswer = "";
    // }
    formStepFieldsDetailsInitial[i].optionId = e.target.value;
    setFormStepFieldsDetailsVerification(formStepFieldsDetailsInitial);
    formStepFieldsDetailsInitial[i].errMsg = '';
  };

  const onMultiBooleanSelectVRFChange = (e, ele, i, multiFieldEle, j) => {
    let { value } = e.target;
    let formStepFieldsDetailsInitial = [...formStepFieldsDetailsVerification];

    if (ele.isConditional == true && multiFieldEle.isDeciding == true) {
      formStepFieldsDetailsInitial[i].optionId = e.target.value;

    }

    // let filterData = formStepFieldsDetailsInitial[i].child[j].options.filter(ele => ele?._id == value);
    // if (filterData[0].optionName == "Yes") {
    //   formStepFieldsDetailsInitial[i].child[j + 1].childAnswer = "";
    // }
    // if (filterData[0].optionName == "No") {
    //   formStepFieldsDetailsInitial[i].child[j + 1].childAnswer = "";
    // }
    formStepFieldsDetailsInitial[i].child[j].optionId = e.target.value;
    setFormStepFieldsDetailsVerification(formStepFieldsDetailsInitial);
    formStepFieldsDetailsInitial[i].errMsg = '';
  };

  const onMultiTextChangeVerification = (e, ele, i, multiFieldEle, j) => {
    let formStepFieldsDetailsInitial = [...formStepFieldsDetailsVerification];
    formStepFieldsDetailsInitial[i].child[j].childAnswer = e.target.value;
    setFormStepFieldsDetailsVerification(formStepFieldsDetailsInitial);
  };

  const setUrlVerification = (data, ele, i) => {
    let formStepFieldsDetailsInitial = [...formStepFieldsDetailsVerification];
    formStepFieldsDetailsInitial[i].answer = data?.data?.Key;
    setFormStepFieldsDetailsVerification(formStepFieldsDetailsInitial);
  };

  // const uploadMultiChildFileVerification = (e, ele, i, multiFieldEle, j) => {

  //   e.preventDefault();
  //   let formData = new FormData();
  //   formData.append("file", e.target.files[0]); 
  //   setIsLoading(true);
  //   onboardingServices
  //     .uploadFile(formData)
  //     .then(function (response) { 
  //       if (response?.data?.success == true) { 
  //         setMultiChildUrl(response?.data?.data, ele, i, multiFieldEle, j)
  //         // formStepFieldsDetailsInitial[i].answer = e.target.value;
  //         // setFormStepFieldsDetails(formStepFieldsDetailsInitial);
  //       }
  //     })
  //     .catch(function (error) { 
  //       openAlert(true, "error", `${error?.response?.data?.message}`);
  //     })
  //     .finally((param) => {
  //       setIsLoading(false);
  //     });
  // };

  // const setMultiChildUrlVerification = (data, ele, i, multiFieldEle, j) => {
  //   let formStepFieldsDetailsInitial = [...formStepFieldsDetailsVerification];
  //   let obj = {
  //     "childquestionId": multiFieldEle?._id,
  //     "childAnswer": data?.data?.Key,
  //     "optionId": null,
  //   }; 
  //   formStepFieldsDetailsInitial[i].childAnswer[j] = obj;
  //   setFormStepFieldsDetailsVerification(formStepFieldsDetailsInitial);
  // };

  const submitForm = () => {
    let bodyDataStepOne = {
      isEdit: false,
      stepId: props?.formStepFieldsDetails?._id,
      formData: {
        _id: props?.formStepFieldsDetails?._id,
        sections: [
          {
            ...props?.formStepFieldsDetails?.sections[0],
            fields: [...formStepFieldsDetails],
          },
          {
            ...props?.formStepFieldsDetails?.sections[1],
            fields: [...formStepFieldsDetailsVerification],
          },
        ],
        viewAccess: props?.formStepFieldsDetails?.viewAccess,
        editAccess: props?.formStepFieldsDetails?.editAccess,
        stepName: props?.formStepFieldsDetails?.stepName,
        createdAt: "2024-02-27T08:53:08.006Z",
        updatedAt: "2024-03-06T16:16:18.564Z",
        __v: 31,
      },
    };
    if (isRequiredValid(bodyDataStepOne?.formData?.sections)?.isValid) {
      props.submitForm(bodyDataStepOne);
    } else {
      setFormStepFieldsDetails(
        isRequiredValid(bodyDataStepOne?.formData?.sections)?.sections[0]
          ?.fields
      );
      setFormStepFieldsDetailsVerification(
        isRequiredValid(bodyDataStepOne?.formData?.sections)?.sections[1]
          ?.fields
      );
      openAlert(true, "error", `Please fill all required fields.`);
    }
  };

  const handleModallClose = () => {
    setIsModalOpen(false);
  };
  const handleModalClose = () => {
    let isError = false;

    let bodyDataStepOne = {
      isEdit: false,
      stepId: props?.formStepFieldsDetails?._id,
      formData: {
        _id: props?.formStepFieldsDetails?._id,
        sections: [
          {
            ...props?.formStepFieldsDetails?.sections[0],
            fields: [...formStepFieldsDetails],
          },
          {
            ...props?.formStepFieldsDetails?.sections[1],
            fields: [...formStepFieldsDetailsVerification],
          },
        ],
        viewAccess: props?.formStepFieldsDetails?.viewAccess,
        editAccess: props?.formStepFieldsDetails?.editAccess,
        stepName: props?.formStepFieldsDetails?.stepName,
        createdAt: "2024-02-27T08:53:08.006Z",
        updatedAt: "2024-03-06T16:16:18.564Z",
        __v: 31,
      },
    };

    let arr = isRequiredValid(bodyDataStepOne?.formData?.sections)?.sections[1]
      ?.fields;
    for (let i = 0; i < arr.length; i++) {
      if (!isEmptyDash(arr[i].errMsg)) {
        isError = true;
      }
    }

    if (isError) {
      setFormStepFieldsDetailsVerification(
        isRequiredValid(bodyDataStepOne?.formData?.sections)?.sections[1]
          ?.fields
      );
      openAlert(true, "error", `Please fill all required fields.`);
    } else {
      setIsModalOpen(false);
    }
  };

  const clearForm = () => {
    // props.onColumnClk(props?.formStepFieldsDetails, 0); 
    const data = isClearformVaild(props?.formStepFieldsDetails.sections, 0);
    setFormStepFieldsDetails(data[0]?.fields);
  };

  const vendorClearForm = () => {
    props.onColumnClk(props?.formStepFieldsDetails, 0);
    const data = isClearformVaild(props?.formStepFieldsDetails.sections, 0);
    setFormStepFieldsDetailsVerification(data[1]?.fields);
  }

  function getFileExtension(filename) {
    return filename.split(".").pop();
  }

  const viewMedia = (data) => {
    // openModal()
    onboardingServices.viewUrlData(data).then(function (response) {
      setFileSrc(response?.data?.data?.url);
      const url = response?.data?.data?.url;
      const filename1 = url.substring(url.lastIndexOf("/") + 1);
      const filename = filename1.split("?")[0];
      const extension = getFileExtension(filename);
      if (
        extension &&
        extension !== "png" &&
        extension !== "jpg" &&
        extension !== "jpeg"
      ) {
        setIsModallOpen(false);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", getFileNameByPath(data));
        document.body.appendChild(link);
        link.click();
      } else {
        setIsModallOpen(true);
      }
    });
  };

  const deleteFile = (index) => {
    const updatedFiles = uploadFilesObj.files.filter((file, i) => i !== index);
    setUploadFilesObj({ ...uploadFilesObj, files: updatedFiles });
    let formStepFieldsDetailsInitial = [...formStepFieldsDetails];
    if (uploadFilesObj?.isChild === true) {
      formStepFieldsDetailsInitial[uploadFilesObj?.i].child[
        uploadFilesObj?.j].files = updatedFiles;
    } else {
      formStepFieldsDetailsInitial[uploadFilesObj?.i].files = updatedFiles;
    }
    setFormStepFieldsDetails(formStepFieldsDetailsInitial);
  };
  return (
    <div className="">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-9 ">
            <div className="form_white-outer">
              <h2 className="lets_text_onboarding_form">
                {props?.formStepFieldsDetails?.sections[0]?.title}
              </h2>

              <div className="must_fill">
                <span>*</span> You must fill in all fields to be able to
                continue
              </div>

              <div>
                <div className="row lets_onboarding_wizard_react">
                  {formStepFieldsDetails.map((ele, i) => (
                    <>
                      {ele.type == "Dropdown" && ele?.display == true && (
                        <div className="col-md-6 lets_onboarding_wizard_react">
                          <div className="input_outer ">
                            <label className="mb-1 text-dark">
                              {ele?.name}
                              {/* {GSTState === '65df2360b57413c5f016f247' ? 'State' : ele?.name} */}
                              {ele?.required && (
                                <span className="required">*</span>
                              )}
                            </label>
                            <select
                              className="form-select w-100 lets_onboarding_wizard_react"
                              aria-label="Default select example"
                              onChange={(e) => onSelectChange(e, ele, i)}
                              value={ele?.optionId}
                              disabled={props?.isDisable}
                            >
                              <option value={"null"}
                                disabled={ele?.name !== 'State'}
                                selected={ele?.name !== 'State'}
                              >
                                Please Select
                              </option>

                              {ele?.options.map((optionEle, i) => (
                                <>
                                  <option value={optionEle?._id}>
                                    {optionEle?.optionName}
                                  </option>
                                </>
                              ))}
                            </select>
                            <span id="businessNameError" className="error">
                              {ele?.errMsg}
                            </span>
                          </div>
                        </div>
                      )}
                      {ele.type == "String" &&
                        ele?.name != "MSME Number" &&
                        ele?.display == true && (
                          <div className="col-md-6 lets_onboarding_wizard_react">
                            <div className="input_outer">
                              <label className="mb-1 text-dark">
                                {ele?.name}
                                {ele?.required && (
                                  <span className="required">*</span>
                                )}
                              </label>
                              <input
                                type="text"
                                className="form-control ob-form-text-input form-h"
                                id="businessName"
                                value={ele?.answer}
                                onChange={(e) => onTextChange(e, ele, i)}
                                disabled={
                                  ele?.name === "Mobile Number" ||
                                    ele?.name === "Email ID"
                                    ? "disabled"
                                    : props?.isDisable
                                }
                              />

                              <span id="businessNameError" className="error">
                                {ele?.errMsg}
                              </span>
                            </div>
                          </div>
                        )}

                      {ele.type == "File" && ele?.display == true && (
                        <div className="col-md-6 lets_onboarding_wizard_react">
                          <div className="input_outer">
                            <label className="mb-1 text-dark">
                              {ele?.name}
                              {ele?.required && (
                                <span className="required">*</span>
                              )}
                            </label>
                            <div class="upload-sec-file">
                              {/* <div>

                              </div> */}
                              {!isEmptyDash(ele.files[0]) && (
                                <>
                                  {" "}
                                  <div className="selected-file-present-div">
                                    {/* <img src={FilePresent} style={{ height: '24px', cursor: 'pointer' }} alt="" onClick={() => viewMedia(ele?.files[0].key)} /> */}
                                    <span className="selected-file-present-text">
                                      Document: {ele?.files?.length}
                                    </span>
                                  </div>

                                  <button
                                    className="btn btn-primary btn-sm"
                                    // disabled={props?.isDisable}
                                    onClick={() =>
                                      handleClick(ele, false, ele?.name, i)
                                    }
                                  >
                                    View
                                  </button>

                                </>
                              )}
                              <input
                                ref={(ref) =>
                                  !fileRef.current.includes(ref) &&
                                  fileRef.current.push(ref)
                                }
                                // ref={fileRef}
                                className="form-control form-hchoose teee"
                                type="file"
                                accept={ele?.validation[0]?.fileTypes}
                                id={ele?.questionId}
                                onChange={(e) => uploadFile(e, ele, i)}
                                disabled={props?.isDisable}
                                style={
                                  isEmptyDash(ele.files[0])
                                    ? { display: "block" }
                                    : { display: "none" }
                                }
                              />
                            </div>
                            <span id="businessNameError" className="error">
                              {ele?.errMsg}
                            </span>
                          </div>
                        </div>
                      )}

                      {/* For Conditional MultiField */}
                      {ele.type == "MultiField" &&
                        ele.isConditional == true &&
                        ele?.display == true && (
                          <div className="col-md-6 lets_onboarding_wizard_react">
                            <div className="row">
                              {ele?.child.map((multiFieldEle, j) => (
                                <>
                                  {multiFieldEle.type == "Dropdown" &&
                                    (ele.optionId ==
                                      multiFieldEle.refOptionId ||
                                      multiFieldEle.isDeciding == true) && (
                                      <div
                                        className={
                                          multiFieldEle.isDeciding == true &&
                                            isEmptyDash(ele.optionId)
                                            ? `col-md-12 lets_onboarding_wizard_react`
                                            : `col-md-6`
                                        }
                                      >
                                        <div className="">
                                          <label className="mb-1 text-dark">
                                            {multiFieldEle?.name}
                                            {ele?.required &&
                                              multiFieldEle.isDeciding ==
                                              true && (
                                                <span className="required">
                                                  *
                                                </span>
                                              )}
                                          </label>

                                          <select
                                            className="form-select w-100"
                                            aria-label="Default select example"
                                            onChange={(e) =>
                                              onMultiSelectChange(
                                                e,
                                                ele,
                                                i,
                                                multiFieldEle,
                                                j
                                              )
                                            }
                                            value={multiFieldEle?.optionId}
                                            disabled={props?.isDisable}
                                          >
                                            <option
                                              value={"null"}
                                              disabled
                                              selected
                                            >
                                              Please Select
                                            </option>
                                            {multiFieldEle?.options.map(
                                              (optionEle, i) => (
                                                <>
                                                  <option
                                                    value={optionEle?._id}
                                                  >
                                                    {optionEle?.optionName}
                                                  </option>
                                                </>
                                              )
                                            )}
                                          </select>
                                        </div>
                                      </div>
                                    )}

                                  {multiFieldEle.type == "String" &&
                                    ele.optionId ==
                                    multiFieldEle.refOptionId && (
                                      <div className="col-md-6 lets_onboarding_wizard_react">
                                        <div className="">
                                          <label className="mb-1 text-dark">
                                            {multiFieldEle?.name}
                                            {/* {ele?.required && (
                                          <span className="required">*</span>
                                        )} */}
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control ob-form-text-input form-h"
                                            id="businessName"
                                            value={multiFieldEle?.childAnswer}
                                            onChange={(e) =>
                                              onMultiTextChange(
                                                e,
                                                ele,
                                                i,
                                                multiFieldEle,
                                                j
                                              )
                                            }
                                            disabled={props?.isDisable}
                                          />
                                          <span
                                            id="businessNameError"
                                            className="error"
                                          ></span>
                                        </div>
                                      </div>
                                    )}

                                  {multiFieldEle.type == "File" &&
                                    ele.optionId ==
                                    multiFieldEle.refOptionId && (
                                      <div className="col-md-6 lets_onboarding_wizard_react">
                                        <div className="">
                                          <label className="mb-1 text-dark">
                                            {multiFieldEle?.name}
                                            {/* {(ele?.required) && <span className="required">*</span>} */}
                                          </label>

                                          <div class="mb-3 upload-sec-file">
                                            {
                                              <>
                                                <div className="selected-file-present-div">
                                                  { }
                                                  {/* <img src={FilePresent} style={{ height: '24px' }} /> */}
                                                  <span className="selected-file-present-text">
                                                    Document:{" "}
                                                    {
                                                      multiFieldEle?.files
                                                        ?.length
                                                    }
                                                  </span>
                                                </div>
                                                <button
                                                  className="btn btn-primary btn-sm"
                                                  // disabled={props?.isDisable}
                                                  onClick={() =>
                                                    handleClick(
                                                      multiFieldEle,
                                                      true,
                                                      ele?.name,
                                                      i,
                                                      j
                                                    )
                                                  }
                                                >
                                                  View
                                                </button>
                                              </>
                                            }
                                            {/* <input
                                          ref={ref => !fileRef.current.includes(ref) && fileRef.current.push(ref)}
                                          // ref={fileRef}
                                          className="form-control form-h choose"
                                          type="file"
                                          accept={ele?.validation[0]?.fileTypes}
                                          id={ele?.questionId}
                                          onChange={(e) => uploadMultiChildFile(e, ele, i, multiFieldEle, j)}
                                          disabled={props?.isDisable}
                                          style={isEmptyDash(multiFieldEle?.files[0]?.key) ? { display: 'block' } : { display: 'none' }}
                                        /> */}
                                          </div>

                                          {/* <div class="mb-3">
                                        <input
                                          className="form-control form-h choose"
                                          type="file"
                                          accept={ele?.validation[0]?.fileTypes}
                                          id=""
                                          onChange={(e) =>
                                            uploadMultiChildFile(
                                              e,
                                              ele,
                                              i,
                                              multiFieldEle,
                                              j
                                            )
                                          }
                                          disabled={props?.isDisable}
                                        />
                                      </div> */}
                                          <span
                                            id="businessNameError"
                                            className="error"
                                          ></span>
                                        </div>
                                      </div>
                                    )}
                                </>
                              ))}
                            </div>
                            <span id="businessNameError" className="error">
                              {ele?.errMsg}
                            </span>
                          </div>
                        )}

                      {/* For Without Conditional MultiField */}
                      {ele.type == "MultiField" &&
                        ele.isConditional != true &&
                        ele?.display == true && (
                          <div className="col-md-6 lets_onboarding_wizard_react">
                            <div className="row">
                              {ele?.child.map((multiFieldEle, j) => (
                                <>
                                  {multiFieldEle.type == "Dropdown" && (
                                    <div className="col-md-6 lets_onboarding_wizard_react">
                                      <div className="">
                                        <label className="mb-1 text-dark">
                                          {multiFieldEle?.name}
                                          {ele?.required && (
                                            <span className="required">*</span>
                                          )}
                                        </label>

                                        <select
                                          className="form-select w-100"
                                          aria-label="Default select example"
                                          onChange={(e) =>
                                            onMultiSelectChange(
                                              e,
                                              ele,
                                              i,
                                              multiFieldEle,
                                              j
                                            )
                                          }
                                          value={multiFieldEle?.optionId}
                                          disabled={props?.isDisable}
                                        >
                                          <option
                                            value={"null"}
                                            disabled
                                            selected
                                          >
                                            Please Select
                                          </option>
                                          {multiFieldEle?.options.map(
                                            (optionEle, i) => (
                                              <>
                                                <option value={optionEle?._id}>
                                                  {optionEle?.optionName}
                                                </option>
                                              </>
                                            )
                                          )}
                                        </select>
                                      </div>
                                    </div>
                                  )}

                                  {multiFieldEle.type == "String" && (
                                    <div className="col-md-6 lets_onboarding_wizard_react">
                                      <div className="">
                                        <label className="mb-1 text-dark">
                                          {multiFieldEle?.name}
                                          {ele?.required && (
                                            <span className="required">*</span>
                                          )}
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control ob-form-text-input form-h"
                                          id="businessName"
                                          value={multiFieldEle?.childAnswer}
                                          onChange={(e) =>
                                            onMultiTextChange(
                                              e,
                                              ele,
                                              i,
                                              multiFieldEle,
                                              j
                                            )
                                          }
                                          disabled={props?.isDisable}
                                        />
                                        <span
                                          id="businessNameError"
                                          className="error"
                                        ></span>
                                      </div>
                                    </div>
                                  )}

                                  {multiFieldEle.type == "File" && (
                                    <div className="col-md-6 lets_onboarding_wizard_react">
                                      <div className="">
                                        <label className="mb-1 text-dark">
                                          {multiFieldEle?.name}
                                          {/* {(ele?.required) && <span className="required">*</span>} */}
                                        </label>

                                        <div class="mb-3 upload-sec-file">
                                          {
                                            <>
                                              <div className="selected-file-present-div">
                                                { }
                                                {/* <img src={FilePresent} style={{ height: '24px' }} /> */}
                                                <span className="selected-file-present-text">
                                                  Document:{" "}
                                                  {multiFieldEle?.files?.length}
                                                </span>
                                              </div>
                                              <button
                                                className="file-upload-btn"
                                                // disabled={props?.isDisable}
                                                onClick={() =>
                                                  handleClick(
                                                    multiFieldEle,
                                                    true,
                                                    ele?.name,
                                                    i,
                                                    j
                                                  )
                                                }
                                              >
                                                View
                                              </button>
                                            </>
                                          }
                                          {/* <input
                                          ref={ref => !fileRef.current.includes(ref) && fileRef.current.push(ref)}
                                          // ref={fileRef}
                                          className="form-control form-h choose"
                                          type="file"
                                          accept={ele?.validation[0]?.fileTypes}
                                          id={ele?.questionId}
                                          onChange={(e) => uploadMultiChildFile(e, ele, i, multiFieldEle, j)}
                                          disabled={props?.isDisable}
                                          style={isEmptyDash(multiFieldEle?.files[0]?.key) ? { display: 'block' } : { display: 'none' }}
                                        /> */}
                                        </div>
                                        <span
                                          id="businessNameError"
                                          className="error"
                                        ></span>
                                      </div>
                                    </div>
                                  )}
                                </>
                              ))}
                            </div>
                            <span id="businessNameError" className="error">
                              {ele?.errMsg}
                            </span>
                          </div>
                        )}
                    </>
                  ))}
                </div>
              </div>
              <div className="input_outer_vendor_onboarding">
                <a
                  href="#"
                  className="vendor_registration"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                >
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-file-earmark-text"
                      viewBox="0 0 16 16"
                    >
                      <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5" />
                      <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z" />
                    </svg>
                  </span>
                  <Button onClick={handleModalOpen}>
                    {" "}
                    Vendor Registration Form {props?.vendorDetails?.onboardingType === 'REGULAR_ONBOARDING' && <span className="required">*</span>}

                  </Button>
                </a>
              </div>
              {!props?.isDisable ? (
                <div className="input_group justify-content-between mt-5 ">
                  <button
                    type="button"
                    className="btn btn-outline-secondary" style={{ borderRadius: "20px" }}
                    onClick={clearForm}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-success save_next_btn"
                    onClick={submitForm}
                  >
                    Save & Next
                  </button>
                </div>
              ) : (<div className="input_group justify-content-between mt-5 "><Button className="view_progress_you" onClick={() => navigateUrl('/admin/onboarding-form-status')}>View Progress</Button></div>)}


            </div>
          </div>
        </div>
      </div>
      <div>
        <Modal
          open={isModalOpen}
          onClose={handleModalClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style1} className="modal_react_controlpanel_employees">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    Vendor Registration Form
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={handleModallClose}
                  ></button>
                </div>
                <div class="modal-body vrf-h-flow">
                  <div class="vendor_registration_form ">
                    <div>
                      {formStepFieldsDetailsVerification.map((ele, i) => (
                        <>
                          {/* {ele.type == "Dropdown" &&
                            ele?.display == true && (
                              <div class="vendor_group lets_onboarding_wizard_reacts">
                                <div class="question wizaed_reacts_onboarding_file">
                                  {ele?.name}
                                </div>

                                <div class="input_outer ">
                                  <div className="react_vendor_registration_form_modal">
                                    <label class="mb-1 text-dark ">
                                      Select Yes/No
                                      {ele?.required && (
                                        <span class="required">*</span>
                                      )}
                                    </label>

                                    <select
                                      class="form-select"
                                      aria-label="Default select example"
                                      fdprocessedid="dlc6k6"
                                      disabled={props?.isDisable}
                                    >
                                      <option selected="">Select</option>
                                      <option value="1">Yes</option>
                                      <option value="2">No</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            )} */}

                          {ele.type == "Dropdown" && ele?.display == true && (
                            <div className="vendor_group lets_onboarding_wizard_reacts">
                              <div class="question wizaed_reacts_onboarding_file">
                                {ele?.name}
                              </div>
                              <div className="input_outer ">
                                <div className="react_vendor_registration_form_modal">
                                  <label class="mb-1 text-dark ">
                                    Select Yes/No
                                    {ele?.required && (
                                      <span class="required">*</span>
                                    )}
                                  </label>

                                  <select
                                    className="form-select vrf-select"
                                    aria-label="Default select example"
                                    onChange={(e) =>
                                      onSelectVRFChange(e, ele, i)
                                    }
                                    value={ele?.optionId}
                                    disabled={props?.isDisable}
                                  >
                                    <option value={"null"} disabled selected>
                                      Please Select
                                    </option>
                                    {ele?.options.map((optionEle, i) => (
                                      <>
                                        <option value={optionEle?._id}>
                                          {optionEle?.optionName}
                                        </option>
                                      </>
                                    ))}
                                  </select>
                                </div>
                                <span id="businessNameError" className="error">
                                  {ele?.errMsg}
                                </span>
                              </div>
                            </div>
                          )}

                          {ele.type == "MultiField" && ele?.display == true && (
                            <div class="vendor_group lets_onboarding_wizard_reacts">
                              <div class="question wizaed_reacts_onboarding_file">
                                {ele?.name}
                              </div>

                              {ele?.child.map((multiFieldEle, j) => (
                                <>
                                  {multiFieldEle?.type == "String" &&
                                    ele.optionId ==
                                    multiFieldEle.refOptionId && (
                                      <div>
                                        <div class="question wizaed_reacts_onboarding_file">
                                          {multiFieldEle?.name}
                                        </div>

                                        <input
                                          type="text"
                                          class="form-control "
                                          fdprocessedid="627aju"
                                          onChange={(e) =>
                                            onMultiTextChangeVerification(
                                              e,
                                              ele,
                                              i,
                                              multiFieldEle,
                                              j
                                            )
                                          }
                                          disabled={props?.isDisable}
                                          value={multiFieldEle?.childAnswer}
                                        />
                                      </div>
                                    )}
                                  {multiFieldEle?.type == "Dropdown" &&
                                    (ele.optionId ==
                                      multiFieldEle.refOptionId ||
                                      multiFieldEle.isDeciding == true) && (
                                      <div class="input_outer">
                                        <div className="react_vendor_registration_form_modal">
                                          <label className="mb-1 text-dark ">
                                            Select Yes/No
                                            {ele?.required && (
                                              <span class="required">*</span>
                                            )}
                                          </label>

                                          <select
                                            class="form-select vrf-select"
                                            aria-label="Default select example"
                                            fdprocessedid="ez4d9s"
                                            onChange={(e) =>
                                              onMultiBooleanSelectVRFChange(
                                                e,
                                                ele,
                                                i,
                                                multiFieldEle,
                                                j
                                              )
                                            }
                                            value={multiFieldEle?.optionId}
                                            disabled={props?.isDisable}
                                          >
                                            <option
                                              value={"null"}
                                              disabled
                                              selected
                                            >
                                              Please Select
                                            </option>
                                            {multiFieldEle?.options.map(
                                              (optionEle, i) => (
                                                <>
                                                  <option
                                                    value={optionEle?._id}
                                                  >
                                                    {optionEle?.optionName}
                                                  </option>
                                                </>
                                              )
                                            )}
                                          </select>
                                        </div>
                                      </div>
                                    )}
                                </>
                              ))}

                              <span id="businessNameError" className="error">
                                {ele?.errMsg}
                              </span>
                            </div>
                          )}
                        </>
                      ))}
                    </div>

                    <div class="input_group justify-content-normal mt-5">
                      <button
                        type="button"
                        className="btn btn-outline-secondary" style={{ borderRadius: "20px" }}
                        fdprocessedid="rkhdf7"
                        onClick={vendorClearForm}
                      >
                        Clear
                      </button>

                      <button
                        type="button"
                        class="btn btn-success save_next_btn"
                        fdprocessedid="yqg3ni"
                        onClick={handleModalClose}

                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </Modal>
      </div>
      <FileViewerModal
        fileSrc={fileSrc}
        isOpen={isModallOpen}
        onClose={closeModal}
      />

      <MediaListModal
        isMediaListModalOpen={isMediaListModalOpen}
        closeMediaListModal={closeMediaListModal}
        uploadObj={uploadFilesObj}
        onUploadMedia={onUploadMedia}
        deleteFile={deleteFile}
        stepStatus={props?.formStepFieldsDetails?.status}
      />

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleClose}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}

export default OnboardingStepOne;
